<ng-container *ngIf="!allShows">
  <app-spinner></app-spinner>
</ng-container>
<ng-container *ngIf="allShows">
  <ng-container *ngIf="showAll">
    <h1>
      <a class="title-link standard" routerLink="/shows">
        Network Shows
      </a>
    </h1>
    <a *ngFor="let show of allShows" routerLink="/shows/{{show.slug || show.id}}">
      <i [responsiveBackgroundImage]="show.logo_square" [widthFactor]="0.1" [mobileWidthFactor]="0.1"></i>
      <span>{{show.name}}</span>
    </a>
  </ng-container>
  <ng-container *ngIf="!showAll">
    <h1 *ngIf="title">
      <a class="title-link standard" routerLink="/shows">{{ title }}</a>
    </h1>

    <a *ngFor="let show of popularShows" routerLink="/shows/{{show.slug || show.id}}">
      <i [responsiveBackgroundImage]="show.logo_square" [widthFactor]="0.1" [mobileWidthFactor]="0.1"></i>
      <span>{{show.name}}</span>
    </a>
    <div>
      <a class="more-shows standard" routerLink="/shows">More</a>
    </div>

    <hr />

    <ng-container *ngIf="audioShows && audioShows.length > 0">
      <h1>Podcast Network</h1>
      <a *ngFor="let show of audioShows" routerLink="/shows/{{show.slug || show.id}}">
        <i [responsiveBackgroundImage]="show.logo_square" [widthFactor]="0.1" [mobileWidthFactor]="0.1"></i>
        <span>{{show.name}}</span>
      </a>
      <hr />
    </ng-container>

    <h1>Articles</h1>
    <a *ngFor="let franchise of franchises" routerLink="/stories/franchise/{{franchise.id}}">
      <i [responsiveBackgroundImage]="franchise.square_logo || franchise.image" [widthFactor]="0.1"
        [mobileWidthFactor]="0.1"></i>
      <span>{{franchise.name}}</span>
    </a>
  </ng-container>

</ng-container>